import { render, staticRenderFns } from "./Confirm.vue?vue&type=template&id=5a6f6867&"
import script from "../../models/booking/confirm.ts?vue&type=script&lang=ts&"
export * from "../../models/booking/confirm.ts?vue&type=script&lang=ts&"
import style0 from "./Confirm.vue?vue&type=style&index=0&id=5a6f6867&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports